// Country / region lists for the mailing-address form (gift page + Profile tab).
// Two-letter ISO codes, matching profile_shipping_addresses.country in puttr-api.

export const COUNTRIES = [
  ['US', 'United States'], ['CA', 'Canada'], ['GB', 'United Kingdom'], ['AU', 'Australia'],
  ['IE', 'Ireland'], ['NZ', 'New Zealand'], ['DE', 'Germany'], ['FR', 'France'], ['IT', 'Italy'],
  ['ES', 'Spain'], ['NL', 'Netherlands'], ['BE', 'Belgium'], ['SE', 'Sweden'], ['NO', 'Norway'],
  ['DK', 'Denmark'], ['FI', 'Finland'], ['CH', 'Switzerland'], ['AT', 'Austria'], ['PT', 'Portugal'],
  ['JP', 'Japan'], ['KR', 'South Korea'], ['SG', 'Singapore'], ['HK', 'Hong Kong'], ['AE', 'United Arab Emirates'],
  ['SA', 'Saudi Arabia'], ['QA', 'Qatar'], ['ZA', 'South Africa'], ['MX', 'Mexico'], ['BR', 'Brazil'],
  ['AR', 'Argentina'], ['CL', 'Chile'], ['DO', 'Dominican Republic'], ['PR', 'Puerto Rico'], ['PA', 'Panama'],
  ['BS', 'Bahamas'], ['TH', 'Thailand'], ['MY', 'Malaysia'], ['PH', 'Philippines'], ['IN', 'India'],
];

export const US_STATES = [
  ['AL', 'Alabama'], ['AK', 'Alaska'], ['AZ', 'Arizona'], ['AR', 'Arkansas'], ['CA', 'California'], ['CO', 'Colorado'],
  ['CT', 'Connecticut'], ['DE', 'Delaware'], ['DC', 'District of Columbia'], ['FL', 'Florida'], ['GA', 'Georgia'],
  ['HI', 'Hawaii'], ['ID', 'Idaho'], ['IL', 'Illinois'], ['IN', 'Indiana'], ['IA', 'Iowa'], ['KS', 'Kansas'],
  ['KY', 'Kentucky'], ['LA', 'Louisiana'], ['ME', 'Maine'], ['MD', 'Maryland'], ['MA', 'Massachusetts'],
  ['MI', 'Michigan'], ['MN', 'Minnesota'], ['MS', 'Mississippi'], ['MO', 'Missouri'], ['MT', 'Montana'],
  ['NE', 'Nebraska'], ['NV', 'Nevada'], ['NH', 'New Hampshire'], ['NJ', 'New Jersey'], ['NM', 'New Mexico'],
  ['NY', 'New York'], ['NC', 'North Carolina'], ['ND', 'North Dakota'], ['OH', 'Ohio'], ['OK', 'Oklahoma'],
  ['OR', 'Oregon'], ['PA', 'Pennsylvania'], ['PR', 'Puerto Rico'], ['RI', 'Rhode Island'], ['SC', 'South Carolina'],
  ['SD', 'South Dakota'], ['TN', 'Tennessee'], ['TX', 'Texas'], ['UT', 'Utah'], ['VT', 'Vermont'], ['VA', 'Virginia'],
  ['WA', 'Washington'], ['WV', 'West Virginia'], ['WI', 'Wisconsin'], ['WY', 'Wyoming'],
];

export const CA_PROVINCES = [
  ['AB', 'Alberta'], ['BC', 'British Columbia'], ['MB', 'Manitoba'], ['NB', 'New Brunswick'],
  ['NL', 'Newfoundland and Labrador'], ['NS', 'Nova Scotia'], ['NT', 'Northwest Territories'], ['NU', 'Nunavut'],
  ['ON', 'Ontario'], ['PE', 'Prince Edward Island'], ['QC', 'Quebec'], ['SK', 'Saskatchewan'], ['YT', 'Yukon'],
];

export function regionsFor(country) {
  if (country === 'US') return US_STATES;
  if (country === 'CA') return CA_PROVINCES;
  return null;
}

export function regionLabel(country) {
  if (country === 'US') return 'State';
  if (country === 'CA') return 'Province';
  if (country === 'GB') return 'County (optional)';
  if (country === 'AU') return 'State';
  return 'State / Province (optional)';
}

export function postcodeLabel(country) {
  if (country === 'US') return 'ZIP code';
  if (country === 'GB') return 'Postcode';
  if (country === 'CA') return 'Postal code';
  return 'Postcode';
}

export function countryName(code) {
  const hit = COUNTRIES.find(c => c[0] === code);
  return hit ? hit[1] : code;
}

// One address as the lines a courier label would show.
export function addressLines(a) {
  if (!a) return [];
  const cityLine = a.country === 'GB'
    ? [a.city, a.zip].filter(Boolean).join(' ')
    : [a.city, [a.province, a.zip].filter(Boolean).join(' ')].filter(Boolean).join(', ');
  return [a.shipName, a.address1, a.address2, cityLine, countryName(a.country)].filter(Boolean);
}
